import { AnimatePresence } from "motion/react";
import { type PropsWithChildren, useRef } from "react";
import type { DropzoneState } from "react-dropzone";
import { useFileExplorerContext } from "./context";
import { FileExplorerDropIndicator } from "./file-explorer-drop-indicator";
import { FileExplorerFooter } from "./file-explorer-footer";
import { FileExplorerPreview } from "./file-explorer-preview";

/** Props Interface */
interface FileExplorerWrapperProps extends PropsWithChildren {
	dropzone: DropzoneState;
}

export function FileExplorerWrapper({ children, dropzone }: FileExplorerWrapperProps) {
	/** Context */
	const { focusedItem } = useFileExplorerContext();

	/** Hooks */
	const containerRef = useRef<HTMLDivElement>(null);

	/** Render */
	return (
		<div
			className="flex flex-col flex-grow-0 gap-2 min-w-0 h-full min-h-0 overflow-hidden relative"
			data-cy="file-explorer"
			{...dropzone.getRootProps()}
		>
			<div
				className="table-container"
				ref={containerRef}
			>
				{dropzone.isDragAccept && <FileExplorerDropIndicator />}
				<div className="w-full h-full flex flex-col">{children}</div>
			</div>
			<FileExplorerFooter />
			<AnimatePresence mode="popLayout">
				{focusedItem && (
					<FileExplorerPreview
						key={focusedItem.type === "folder" ? focusedItem.name : focusedItem.file.id}
						focusedItem={focusedItem}
						containerRef={containerRef}
					/>
				)}
			</AnimatePresence>
		</div>
	);
}
